export const SORTING = {
  DEFAULT: 'relevance-desc',
};
